export { analyzeTemplateRequirements } from './analyze-requirements'
export { commandsFromPlans } from './commands-from-plans'
export { escapeZplText } from './escape-zpl-text'
export { evaluateRules } from './evaluate-rules'
export { flattenZones } from './flatten-zones'
export type { FlatZone } from './flatten-zones'
export { generateZpl } from './generate-zpl'
export type { GenerateZplOptions, GenerateZplResponse } from './generate-zpl'
export { lintTemplate } from './lint-template'
export { buildRenderPlan } from './render-plan'
export { buildAuthoringPlan } from './build-authoring-plan'
export { splitChildBoxes, type Box } from './split'
export { collectRegionBorders, dedupeBorderSegments } from './region-borders'
export type { BorderSegment, BorderLeaf } from './region-borders'
export { projectPlacement } from './place-baked-instance'
export { capBandAnchorY, A0_VMETRICS } from './internal/intrinsic-size'
export type { FontVMetrics } from './internal/intrinsic-size'
export type { RenderPlan } from './render-plan'
export { serializeZpl } from './serialize'
export type { TemplateRequirements } from './analyze-requirements'
export { resolveContent } from './variables'
export type { ZplCommand } from './zpl-command'
export { resolvePrintRotation, rotateFlatZones } from './rotate-flat-zones'
export type { ResolvedPrintRotation } from './rotate-flat-zones'

export const PIPELINE_VERSION = '0.0.1'
